// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5d2b8a9d","453":"5d823274","455":"617e90df"}[chunkId] + ".chunk.js";
};